import { Legacy, BeaconSeed } from '@/infrastructure/network/Legacy/schema'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'
import { IParamsProps } from '@/entities/Legacy/Options'

export class GetBeacon implements APIRequest<Legacy.Beacon.getBeaconResponse> {
  response: Legacy.Beacon.getBeaconResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(hospitalId: string, beaconId: string) {
    this.path = `/beacons/${hospitalId}/${beaconId}`
  }
}

export class GetBeacons implements APIRequest<Legacy.Beacon.getBeaconsResponse> {
  response: Legacy.Beacon.getBeaconsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params: IParamsProps
  constructor(hospitalId: string, params: IParamsProps) {
    this.params = params
    this.path = `/beacons/${hospitalId}`
  }
}

export class PostBeacon implements APIRequest<Legacy.Beacon.postBeaconResponse> {
  response: Legacy.Beacon.postBeaconResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Legacy.Beacon.postBeaconRequest
  constructor(hospitalId: string, params: BeaconSeed) {
    this.params = params
    this.path = `/beacons/${hospitalId}`
  }
}

export class PutBeacon implements APIRequest<Legacy.Beacon.putBeaconResponse> {
  response: Legacy.Beacon.putBeaconResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Legacy.Beacon.putBeaconRequest
  constructor(hospitalId: string, params: BeaconSeed) {
    const beaconId = params.id
    this.params = params
    this.path = `/beacons/${hospitalId}/${beaconId}`
  }
}

export class DeleteBeacon implements APIRequest<Legacy.Beacon.deleteBeaconResponse> {
  response: Legacy.Beacon.deleteBeaconResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(hospitalId: string, beaconId: string) {
    this.path = `/beacons/${hospitalId}/${beaconId}`
  }
}

export class GetCheckinBeacons implements APIRequest<Legacy.Beacon.getCheckinBeaconsResponse> {
  response: Legacy.Beacon.getCheckinBeaconsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(hospitalId: string) {
    this.path = `/beacons/${hospitalId}/checkinbeacon`
    // this.path = `/hospitals/${hospitalId}/checkinbeacon`
  }
}

export class GetUserCheckinBeacons implements APIRequest<Legacy.Beacon.getUserCheckinBeaconsResponse> {
  response: Legacy.Beacon.getUserCheckinBeaconsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(hospitalId: string, userId: string) {
    this.path = `/beacons/${hospitalId}/checkinbeacon/${userId}`
    // this.path = `/hospitals/${hospitalId}/checkinbeacon`
  }
}
